import LoadingQuestion from 'components/LoadingComponents/LoadingQuestion';
import {Button} from 'letrus-ui';
import {QuestionSubmitParams} from 'containers/PracticeTest';
import {EnrichedQuestion} from 'utils/types/questionnaires';
import styles from './Statement.module.scss';

export interface StatementProps {
  question: EnrichedQuestion;
  onGoBack(): void;
  goToNextQuestion(): void;
  onQuestionSubmit(params: QuestionSubmitParams): void;
  isLoading: boolean;
  disableTextSelection?: boolean;
}

function Statement({
  question,
  onGoBack,
  onQuestionSubmit,
  goToNextQuestion,
  isLoading,
  disableTextSelection = false,
}: StatementProps): JSX.Element {
  const handleForwardClick = () => {
    onQuestionSubmit({
      questionId: question?.id,
      answer: '',
      responses: [],
    });
    goToNextQuestion();
  };

  return isLoading ? (
    <LoadingQuestion questionType="statement" />
  ) : (
    <div
      className={`${styles.wrapper} ${
        disableTextSelection ? styles.disableTextSelection : ''
      }`}
    >
      <div
        dangerouslySetInnerHTML={{
          __html: question?.text,
        }}
      />
      <div className={styles.buttons}>
        <Button
          type="button"
          variant="secondary"
          onClick={onGoBack}
          disabled={question.order === 1}
        >
          Voltar
        </Button>
        <Button type="button" variant="primary" onClick={handleForwardClick}>
          {question?.button_text || 'Próxima'}
        </Button>
      </div>
    </div>
  );
}

export default Statement;
